import React from 'react';
import { TabItem, TabText } from './styled';

interface SearchTabProps {
  name: string;
  text: string;
  currentTabId: number;
  tabId: number;
  switchTab: React.Dispatch<React.SetStateAction<number>>;
  itemsCount: number;
  disabled: boolean;
  stat?: string;
}

export const SearchTab = ({
  name,
  text,
  tabId,
  currentTabId,
  switchTab,
  itemsCount,
  disabled,
  stat
}: SearchTabProps) => {
  const handleClick = () => {
    if (disabled) return;
    switchTab(tabId);
  };

  return (
    <TabItem
      $isSelected={tabId === currentTabId}
      id={`quick-links-tab-${name}`}
      onClick={handleClick}
      onKeyPress={handleClick}
      role="tab"
      disabled={disabled}
      data-stat={stat}
    >
      <TabText tag="body_2" $isSelected={tabId === currentTabId}>
        {`${text}${itemsCount ? ` (${itemsCount})` : ''}`}
      </TabText>
    </TabItem>
  );
};
